<template>
  <div id="AdminNewsletterCampaign1">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">Newsletter</li>
      <li class="breadcrumb-item active">
      <button class="btn btn-link" @click="confirmCancelNewEmail" style="padding: 0px; margin-top: -2px;">Campagne</button>  
        <!--<router-link :to="url"  
        @click="confirmCancelNewEmail">Campagne</router-link> --->
      </li>
    </ol>
    <div class="container-fluid card-title-admin">
      <h1>Campagne</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane active" id="tabTable" role="tabpanel">
            <div class="row align-btns">
              <div class="col-12 text-left">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onNewCampaign"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="TableConfiguration"
                  :datas="tableData"
                  id="tableCustomer"
                  :onCheck="onTableCheckEmail"
                  :onCheckAll="onTableCheckEmail"
                  :onUncheck="onTableCheckEmail"
                  :onUncheckAll="onTableCheckEmail"
                  ref="tableCustomer"
                  :results="tableResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
            <div class="card-body">
              <form id="frmSendMessage">
                <div
                  class="col-12"
                  style="
                    border: 1px solid #c8ced3;
                    padding: 21px;
                    margin-top: -1px;
                    border-radius: 10px 10px 10px 10px;
                  "
                >
                  <div class="row">                   
                    <div class="col-8 text-align:center">
                      <h5 for="title">Titolo Campagna</h5>
                      <input
                        type="text"
                        class="form-control"
                        id="title"
                        required="required"
                        name="title"
                        placeholder="Il titolo è un semplice identificativo ad uso interno che non verrà in alcun modo visualizzato dai destinatari finali."
                        @change="onchangetitle"
                      />
                    </div>
                    <div class="col-2 text-align:center">
                      <h5 for="schedule_date_time">Data di invio</h5>
                      <date-picker
                        placeholder="Data di invio"
                        required="required"
                        id="schedule_date_time"
                        name="schedule_date_time"
                        :config="configDateTime"
                      ></date-picker>
                    </div>
                    <div class="col-2 align-self-center" id="coldraft1">
                      <h5 for="switch-scheduler" style="margin-left: 21px">
                        Bozza
                      </h5>
                      <div class="form-check">
                        <label
                          class="switch switch-pill switch-primary"
                          style="margin: 2px; vertical-align: bottom"
                        >
                          <input
                            v-if="rowIdSelected > 0"
                            :id="'draft1'"
                            type="checkbox"
                            name="draft1"
                            class="switch-input draft1"
                            :checked="draftresult"
                          />
                          <input
                            v-else
                            :id="'draft1'"
                            type="checkbox"
                            name="draft1"
                            class="switch-input draft1"
                            checked="checked"
                          />
                          <div class="switch-slider"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-8">
                      <div class="row">
                        <div class="col-6">
                          <h5 for="sender">
                            Mittente
                            <span
                              style="
                                font-size: 14px;
                                float: right;
                                color: #999;
                                font-weight: lighter;
                                font-style: italic;
                              "
                              id="output_sottr_sender"
                            >
                              Caratteri rimanenti: 100</span
                            >
                            <input
                              class="form-control"
                              type="hidden"
                              id="output"
                            />
                            <input
                              type="text"
                              class="form-control"
                              id="sender"
                              required="required"
                              name="sender"
                              placeholder="Mittente"
                              v-on:keyup="ValueTextSender"
                            />
                          </h5>
                        </div>
                        <div class="col-6">
                          <h5 for="sender_email">
                            <br />
                            <font
                              style="
                                font-size: 14px;
                                color: #999;
                                font-weight: lighter;
                                font-style: italic;
                              "
                            >
                              <input
                                type="text"
                                class="form-control"
                                id="sender_email"
                                required="required"
                                name="sender_email"
                                placeholder="Email"
                                v-on:keyup="writebtnsendemailtest"
                            /></font>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-8">
                      <div class="row">
                        <div class="col-6">
                          <h5 for="object">
                            Oggetto
                            <span
                              style="
                                font-size: 14px;
                                float: right;
                                color: #999;
                                font-weight: lighter;
                                font-style: italic;
                              "
                              id="object_sottr_object"
                            >
                              Caratteri rimanenti: 150</span
                            >
                            <input
                              class="form-control"
                              type="hidden"
                              id="output_object"
                            />
                            <input
                              type="text"
                              class="form-control"
                              id="object"
                              required="true"
                              name="object"
                              placeholder="Oggetto"
                              v-on:keyup="ValueTextSenderObject"
                            />
                          </h5>
                        </div>
                        <div class="col-6">
                          <h5 for="preview_object">
                            <span
                              style="
                                font-size: 14px;
                                float: right;
                                color: #999;
                                font-weight: lighter;
                                font-style: italic;
                              "
                              id="preview_sottr_object"
                            >
                              Caratteri rimanenti: 150</span
                            >
                            <input
                              class="form-control"
                              type="hidden"
                              id="output_preview_object"
                            />
                            <input
                              type="text"
                              class="form-control"
                              id="preview_object"
                              required="true"
                              name="preview_object"
                              placeholder="Preview"
                              v-on:keyup="ValueTextPreviewObject"
                            />
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="row">
                        <div class="col-8">
                          <h5 for="url">
                            Url
                            <input
                              type="text"
                              class="form-control"
                              id="url"
                              required
                              name="url"
                              placeholder="Url"
                            />
                          </h5>
                        </div>
                        <div class="col-4">
                          <button
                            style="margin-top: 20px"
                            id="btnPreview"
                            class="btn btn-light"
                            @click="previewClick"
                          >
                            Anteprima
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <div class="row">
               
                  <div class="col-12">
                    <h5 for="text">Testo</h5>
                    <pageDetail
                      functions="AdminNewsletterCampaign1"
                      :configurations="DetailHtmlConfiguration"
                      :jsonValue="detailData"
                    ></pageDetail>
                  </div>
                </div>

                <div
                  class="col-12"
                  style="
                    border: 1px solid #c8ced3;
                    margin-top: 9px;
                    border-radius: 10px 10px 10px 10px;
                  "
                >
                  <div class="row form-textarea">
                    <div class="col-12" style="padding: 0px; margin-left: 18px">
                      <h5 for="text_message">
                        Conversione Url
                        <font
                          style="
                            font-size: 14px;
                            color: #999;
                            font-weight: lighter;
                            font-style: italic;
                          "
                          >(per inserire un link breve all'interno del
                          messaggio)</font
                        >
                      </h5>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 align-self-center">
                      <label for="original_url"></label>
                      <input
                        type="text"
                        class="form-control"
                        id="original_url"
                        name="original_url"
                        placeholder="https://www.example.com/long-url-with-many-characters/1234567890120/"
                      />
                    </div>
                    <div class="col-2 align-self-center">
                      <button
                        style="
                          width: 130px;
                          margin-left: -18px;
                          margin-top: 21px;
                        "
                        type="button"
                        class="btn btn-success"
                        data-dismiss="modal"
                        @click="formatTinyUrl"
                      >
                        <i class="fa fa-window-minimize"></i>&nbsp;Converti
                      </button>
                    </div>
                    <div
                      class="col-2 align-self-center"
                      style="
                        margin-left: -36px;
                        font-size: 18px;
                        margin-top: -10px;
                      "
                    >
                      <label></label><br />
                      <span id="short-url">&nbsp;</span>
                    </div>

                    <div
                      class="col-2 align-self-center"
                      id="btncopyshorturl"
                      style="
                        margin-left: -110px;
                        font-size: 18px;
                        margin-top: -10px;
                      "
                    >
                      <label></label><br />
                      <button
                        style="
                          width: 300px;
                          margin-top: 3px;
                          font-size: 18px;
                          margin-left: -18px;
                          color: #23282c;
                        "
                        type="button"
                        class="btn btn-link"
                        data-dismiss="modal"
                        @click="formatCopyUrlShort"
                      >
                        <img
                          src="https://selena.tecnotrade.com/storage/images/icon_copy.png"
                          style="height: 39px"
                        /><span
                          style="
                            font-size: 18px;
                            font: Avenir, Helvetica, Arial, sans-serif;
                          "
                          >Copia</span
                        >
                      </button>
                    </div>

                    <input
                      type="text"
                      class="form-control"
                      id="copyText"
                      style="border-color: #fff"
                    />
                  </div>
                </div>
              </form>
              <br /><br />
              <div
                class="col-12"
                style="
                  border: 1px solid #c8ced3;
                  padding: 21px;
                  margin-top: -23px;
                  border-radius: 10px 10px 10px 10px;
                "
              >
                <div class="row">
                  <!-- column list number -->
                  <div class="col-8">
                    <!--  tab nav dettaglio selezione numeri destinatari--->
                    <div
                      class="tab-pane nopadding"
                      style="box-shadow: none"
                      id="tabNavSelectRecipient"
                      role="tabpanel"
                    >
                      <div class="row">
                        <div class="col-12" style="margin-top: -14px">
                          <h5 style="margin-top: 10px">
                            Seleziona i destinatari
                          </h5>
                        </div>
                        <div class="col-12">
                          <ul class="nav nav-tabs">
                            <li class="nav-item">
                              <button
                                id="tabAdminGroupContactEmail"
                                type="button"
                                class="nav-link"
                                data-toggle="tab"
                                href="#tabAdminGroupContactEmail"
                                role="tab"
                                aria-controls="tabAdminGroupContactEmail"
                                v-on:click="ontabAdminGroupContactEmail"
                              >
                                <span>Liste</span>
                              </button>
                            </li>
                            <li class="nav-item">
                              <button
                                id="tabAdminContactEmail"
                                type="button"
                                class="nav-link"
                                data-toggle="tab"
                                href="#tabAdminContactEmail"
                                role="tab"
                                aria-controls="tabAdminContactEmail"
                                v-on:click="ontabAdminContactEmail"
                              >
                                <span>Contatti</span>
                              </button>
                            </li>
                            <li class="nav-item">
                              <button
                                id="tabAdminMassiveEmail"
                                type="button"
                                class="nav-link"
                                data-toggle="tab"
                                href="#tabAdminMassiveEmail"
                                role="tab"
                                aria-controls="tabAdminMassiveEmail"
                                v-on:click="ontabAdminMassiveEmail"
                              >
                                <span>Massivo</span>
                              </button>
                            </li>
                            <li class="nav-item">
                              <button
                                id="tabAdminEmail"
                                type="button"
                                class="nav-link active"
                                data-toggle="tab"
                                href="#tabAdminEmail"
                                role="tab"
                                aria-controls="tabAdminEmail"
                                v-on:click="ontabAdminEmail"
                              >
                                <span>Singolo</span>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!--  end tab nav dettaglio selezione numeri destinatari--->
                    <div class="tab-content" style="border: 0px solid #c8ced3">
                      <!--   tab  detailSingleEmail  --->
                      <div
                        class="card-body active tab-pane"
                        id="detailSingleEmail"
                        role="tabpanel"
                        style="
                          padding-left: 0px;
                          padding-right: 0px;
                          box-shadow: none;
                        "
                      >
                        <div class="row">
                          <div class="col-4 align-self-center">
                            <div class="">
                              <label
                                class="form-check-label"
                                for="checkInsManual"
                              >
                                Inserimento Manuale
                              </label>
                            </div>
                          </div>
                          <div class="col-8 align-self-center">
                            <input
                              type="email"
                              class="form-control"
                              id="email"
                              name="email"
                              placeholder="info@tecnotrade.com"
                            />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 text-right">
                            <button
                              style="margin-top: 15px"
                              type="button"
                              class="btn btn-success"
                              data-dismiss="modal"
                              @click="addMailToList"
                            >
                              <i class="fa fa-plus"></i>&nbsp;Aggiungi email
                            </button>
                          </div>
                        </div>
                      </div>
                      <!--  end tab detailSingleEmail --->
                      <!--  tab massive email  --->
                      <div
                        class="card-body tab-pane"
                        id="detailMassiveEmail"
                        role="tabpanel"
                        style="
                          padding-left: 0px;
                          padding-right: 0px;
                          box-shadow: none;
                        "
                      >
                        <div class="row">
                          <div class="col-6 align-self-center">
                            <div class="">
                              <label
                                class="form-check-label"
                                for="checkMassive"
                              >
                                Inserimento Massivo
                              </label>
                            </div>
                            <textarea
                              style="width: 260px !important; height: 93px"
                              class="form-control"
                              :id="'email_massive'"
                              :name="'email_massive'"
                            />
                          </div>
                          <div class="col-6 align-self-center">
                            <p>
                              Esempio:<br />
                              info@tecnotrade.com<br />
                              info1@tecnotrade.com<br />
                              info2@tecnotrade.com<br />
                              info3@tecnotrade.com<br />
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 text-right">
                            <button
                              style="margin-top: 15px"
                              type="button"
                              class="btn btn-success"
                              data-dismiss="modal"
                              @click="addEmailMassiveToList"
                            >
                              <i class="fa fa-plus"></i>&nbsp; Aggiungi email
                            </button>
                          </div>
                        </div>
                      </div>
                      <!--  end tab massive email--->

                      <!--   tab  detailContactClient  --->
                      <div
                        class="card-body tab-pane"
                        id="detailContactClient"
                        role="tabpanel"
                        style="
                          padding-left: 0px;
                          padding-right: 0px;
                          box-shadow: none;
                        "
                      >
                        <div class="row" style="margin-bottom: 10px">
                          <div class="col-6">
                            <label>Seleziona Destinatario Contatti</label><br />
                            <select
                              class="custom-select user_id"
                              style="width: 100% !important"
                              id="user_id"
                              name="user_id"
                            ></select>
                          </div>
                          <div class="col-6">
                            <label>Email</label><br />
                            <input
                              type="text"
                              class="form-control email_select_contact"
                              id="email_select_contact"
                              name="email_select_contact"
                            />
                          </div>
                        </div>
                        <div class="row" style="margin-bottom: 10px">
                          <div class="col-6">
                            <label>Seleziona Destinatario Utenti</label><br />
                            <select
                              class="custom-select user_id_users"
                              style="width: 100% !important"
                              id="user_id_users"
                              name="user_id_users"
                            ></select>
                          </div>
                          <div class="col-6">
                            <label>Email</label><br />
                            <input
                              type="text"
                              class="form-control emailuser_select_contact"
                              id="emailuser_select_contact"
                              name="emailuser_select_contact"
                            />
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-12 text-right">
                            <button
                              style="margin-top: 15px"
                              type="button"
                              class="btn btn-success"
                              data-dismiss="modal"
                              @click="addEmailContactToList"
                            >
                              <i class="fa fa-plus"></i>&nbsp;Aggiungi contatto
                            </button>
                          </div>
                        </div>
                      </div>
                      <!--  end tab detailContactClient --->

                      <!--   tab  detailGroupContactClient  --->
                      <div
                        class="card-body tab-pane"
                        id="detailGroupContactClient"
                        role="tabpanel"
                        style="
                          padding-left: 0px;
                          padding-right: 0px;
                          box-shadow: none;
                        "
                      >
                        <div class="row" style="margin-bottom: 10px">
                          <div class="col-6">
                            <label>Seleziona gruppo contatti</label><br />
                            <select
                              class="custom-select groupEmail"
                              style="width: 100% !important"
                              id="groupEmail"
                              name="groupEmail"
                            ></select>
                          </div>
                          <div class="col-6">
                            <div class="row">
                              <div class="col-12">
                                <label>Preview Email</label><br />
                              </div>
                            </div>
                            <div class="row">
                              <div
                                class="col-12 align-self-center"
                                v-if="listEmailGroupDetailSend.length > 0"
                                style="max-height: 250px; overflow: auto"
                              >
                                <div
                                  v-for="listEmailGroup in listEmailGroupDetailSend"
                                  v-bind:key="listEmailGroup.id"
                                >
                                  {{ listEmailGroup.email }}
                                </div>
                              </div>
                              <div class="col-12 text-center" v-else>
                                <p>Nessun gruppo selezionato!</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row" style="margin-bottom: 10px">
                          <div class="col-6">
                            <label>Seleziona gruppo query</label><br />
                            <select
                              class="custom-select groupEmail"
                              style="width: 100% !important"
                              id="groupEmailQueryGroup"
                              name="groupEmailQueryGroup"
                            ></select>
                          </div>
                          <div class="col-6">
                            <div class="row">
                              <div class="col-12">
                                <label>Preview Email Query</label><br />
                              </div>
                            </div>
                            <div class="row">
                              <div
                                class="col-12 align-self-center"
                                v-if="listNewsletterGroupQueryEmail.length > 0"
                                style="max-height: 250px; overflow: auto"
                              >
                                <div
                                  v-for="listEmailGroupQuery in listNewsletterGroupQueryEmail"
                                  v-bind:key="listEmailGroupQuery"
                                >
                                  {{ listEmailGroupQuery }}
                                </div>
                              </div>
                              <div class="col-12 text-center" v-else>
                                <p>Nessun gruppo query selezionato!</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-12 text-right">
                            <button
                              style="margin-top: 15px"
                              type="button"
                              class="btn btn-success"
                              data-dismiss="modal"
                              @click="addEmailGroupContactToList"
                            >
                              <i class="fa fa-plus"></i>&nbsp;Aggiungi gruppo
                            </button>
                          </div>
                        </div>
                      </div>
                      <!--  end tab detailGroupContactClient --->
                    </div>
                  </div>
                  <!-- end column list number -->

                  <!-- column resoconto + cancellazione array -->
                  <div
                    class="col-4"
                    style="border-left: 2px groove #ededed; padding-top: 0px"
                  >
                    <h5>Lista Email</h5>
                    <span
                      style="
                        font-size: 15px;
                        float: right;
                        margin-top: -30px;
                        color: #999;
                        font-weight: lighter;
                        font-style: italic;
                      "
                      >{{ listData }}&nbsp;indirizzi</span
                    >
                    <div
                      class="col-12 align-self-center"
                      style="max-height: 250px; overflow: auto"
                    >
                      <div class="row">
                        <div class="col-1" style="margin-left: -13px">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id="CheckCheckedAll"
                              @change="onChangeCheckAll"
                            />
                          </div>
                        </div>
                        <div class="col-5">
                          <select
                            v-model="selected"
                            class="form-control"
                            id="tipology_search"
                            name="tipology_search"
                            required="required"
                            placeholder="Seleziona"
                            @change="Search()"
                          >
                            <option value="Email">Email</option>
                            <option value="Gruppo">Gruppo</option>
                          </select>
                        </div>
                        <div class="col-5">
                          <input
                            type="text"
                            class="form-control"
                            id="search1"
                            required="required"
                            name="search1"
                            placeholder="Cerca"
                            @keyup="Search()"
                          />
                        </div>
                        <div class="col-1 text-right" style="margin-left: 13px">
                          <i
                            class="fa fa-trash"
                            @click="delEmailListChecked()"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-12 align-self-center"
                        v-if="listEmail.length > 0"
                        style="max-height: 250px; overflow: auto"
                      >
                        <div
                          v-for="listEmails in listEmail"
                          v-bind:key="listEmails"
                        >
                          <div
                            class="cont-single-email"
                            style="margin-left: 25px"
                            v-if="listEmails.visible"
                          >
                            <input
                              class="form-check-input"
                              style="margin-left: -36px"
                              type="checkbox"
                              value=""
                              id="CheckChecked"
                              :checked="listEmails.checked"
                            />
                            {{ listEmails.email }}&nbsp;&nbsp;&nbsp;({{
                              listEmails.group
                            }})
                            <i
                              class="fa fa-trash"
                              id="deleteEmailList"
                              @click="delEmailList(listEmails)"
                            ></i>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 text-center" v-else>
                        <p>Nessuna email presente!</p>
                      </div>
                    </div>
                    <br />
                    <span><b>Riepilogo:</b></span
                    ><br />
                    <span
                      ><b>Numero destinatari:&nbsp;{{ listData }}</b></span
                    ><br />
                    <span
                      ><b
                        >Durata dell'invio:&nbsp;{{
                          sending_duration
                        }}
                        Secondi</b
                      ></span
                    ><br />
                    <span
                      ><b
                        >Ora di fine stimata:&nbsp;{{ sommaorafinestimata }}</b
                      ></span
                    ><br />
                  </div>
                  <!-- end column resoconto + cancellazione array-->
                </div>

                <div class="row">
                  <div class="col-12 text-right">
                    <button
                      type="button"
                      class="btn btn-danger"
                      data-dismiss="modal"
                      @click="confirmCancelNewEmail"
                    >
                      <i class="fa fa-times"></i>&nbsp;Indietro
                    </button>
                    <button
                      type="button"
                      class="btn btn-success"
                      @click="confirmSendMailTestSender"
                    >
                      <i class="fa fa-paper-plane"></i>&nbsp;Invia messaggio a
                      {{ send }}
                    </button>
                    <button
                      id="btnsave"
                      type="button"
                      class="btn btn-success"
                      @click="confirmSaveNewEmail"
                    >
                      <i class="fa fa-floppy-o"></i>&nbsp;{{ save }}
                    </button>
                  </div>
                </div>
              </div>
              <!--Chiusura del bordo-->
            </div>
          </div>

          <!-- graphic feedback -->
          <div
            class="modal"
            id="tabAdminNewsletterResocontoList"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg" role="document" style="max-width: 90%!important;">
              <div class="modal-content padding" style="min-height: 94vh;">
                <div class="modal-header text-center">
                  <h2
                    class="modal-title w-100 font-weight-bold"
                    style="color: #73818f !important"
                  >
                    Resoconto Campagna
                  </h2>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body mx-12">
                  <div class="md-form mb-12">
                    <div class="row">
                      <div class="col-sm-12 col-lg-4">
                        <div class="card" style="border-color: #fff !important">
                          <div
                            class="
                              text-muted text-uppercase
                              font-weight-bold
                              small
                            "
                            style="font-size: 13px"
                          >
                            Titolo<br />
                            <label
                              class="
                                text-muted text-lowercase
                                font-weight-bold
                                small
                              "
                              style="font-size: 19px"
                              >{{ chartsResult.title }}</label
                            >
                          </div>
                          <div
                            class="
                              text-muted text-uppercase
                              font-weight-bold
                              small
                            "
                            style="font-size: 13px"
                          >
                            Oggetto<br />
                            <label
                              class="
                                text-muted text-lowercase
                                font-weight-bold
                                small
                              "
                              style="font-size: 19px"
                              >{{ chartsResult.object }}</label
                            >
                          </div>

                          <div
                            class="
                              text-muted text-uppercase
                              font-weight-bold
                              small
                            "
                            style="font-size: 13px"
                          >
                            Data Invio<br />
                            <label
                              class="
                                text-muted text-lowercase
                                font-weight-bold
                                small
                              "
                              style="font-size: 19px"
                              >{{ chartsResult.start_send_date_time }}</label
                            >
                          </div>

                          <div
                            class="
                              text-muted text-uppercase
                              font-weight-bold
                              small
                            "
                            style="font-size: 13px"
                          >
                            Nr Destinatari<br />
                            <label
                              class="
                                text-muted text-lowercase
                                font-weight-bold
                                small
                              "
                              style="font-size: 19px"
                              >{{ chartsResult.nr_recipients }}</label
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-lg-4"
                        v-for="chart in charts"
                        v-bind:key="chart.title"
                      >
                        <div class="card">
                          <graphic :configurations="chart" />
                        </div>
                      </div>
                      <!-- --->
                      <div class="col-sm-12 col-lg-4">
                        <div class="card">
                          <div class="card-body p-3 d-flex align-items-center">
                            <i
                              class="
                                fa fa-envelope-open
                                bg-light
                                p-3
                                font-2xl
                                mr-3
                              "
                              style="color: aquamarine"
                            ></i>
                            <div>
                              <div class="text-value-sm" style="color: aquamarine">
                                {{ chartsResult.countOpened }}
                              </div>
                              <div
                                class="
                                  text-muted text-uppercase
                                  font-weight-bold
                                  small
                                "
                              >
                                Aperte
                              </div>
                            </div>
                       <div class="col-6" style="text-align:left">
                         <button class="btn btn-link"
                          @click="onclickviewlistmailopen">
                            <i class="fa fa-search fa-2x"></i></button></div>
                          </div>
                        </div>
                        <br>
                         <div class="card">
                          <div class="card-body p-3 d-flex align-items-center">
                            <i
                              class="
                                fa fa-exclamation-triangle
                                bg-danger
                                p-3
                                font-2xl
                                mr-3
                              "
                            ></i>
                            <div>
                              <div class="text-value-sm text-danger">
                                {{ chartsResult.countToError }}
                              </div>
                              <div
                                class="
                                  text-muted text-uppercase
                                  font-weight-bold
                                  small
                                "
                              >
                                In Errore
                              </div>
                            </div>
                          <div class="col-6" style="text-align:left">
                            <button class="btn btn-link"
                            @click="onclickviewlistmailerror">
                            <i class="fa fa-search fa-2x"></i>
                            </button>
                          </div>
                          </div>
                        </div>
                      </div>
                         <!-- --->
                    </div>
                    <div class="row">
                      <div
                        class="col-sm-12 col-lg-6"
                        v-for="charty in chartsres"
                        v-bind:key="charty.title"
                      >
                        <div class="card">
                          <graphic :configurations="charty" />
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-lg-6"
                        v-for="charttime in chartsrestime"
                        v-bind:key="charttime.title"
                      >
                        <div class="card">
                          <graphic :configurations="charttime" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- graphic feedback -->

          <!--tabAdminNewsletterPopupDuplicate -->
          <div
            class="modal"
            id="tabAdminNewsletterPopupDuplicate"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content padding">
                <div class="modal-header text-center">
                  <h2 class="modal-title w-100 font-weight-bold">
                    Duplica Campagna
                  </h2>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div
                  class="modal-header text-center"
                  style="border-bottom: 1rem"
                >
                  <h6 class="modal-title w-100 font-weight-bold">
                    Questa procedura creerà una nuova campagna. Selezionare
                    "Duplica il contenuto" per riportare titolo, mittente,
                    oggetto, preview e corpo del messaggio. Selezionare "Duplica
                    i destinatari" per riportare tutte le selezioni effettuate
                    per compilare l'elenco delle email.
                  </h6>
                </div>
                <div class="modal-body mx-12">
                  <div class="md-form mb-12">
                    <div class="row">
                      <div class="col-6">
                        <div class="form-check">
                          <label
                            class="switch switch-pill switch-primary"
                            style="margin: 2px; vertical-align: bottom"
                          >
                            <input
                              :id="'duplicatecontent'"
                              type="checkbox"
                              name="duplicatecontent"
                              checked="true"
                              class="switch-input duplicatecontent"
                            />
                            <div class="switch-slider"></div> </label
                          >&nbsp;&nbsp;
                          <span style="font-size: 18px"
                            >Duplica il contenuto</span>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-check">
                          <label
                            class="switch switch-pill switch-primary"
                            style="margin: 2px; vertical-align: bottom"
                          >
                            <input
                              :id="'duplicaterecipients'"
                              type="checkbox"
                              name="duplicaterecipients"
                              checked="true"
                              class="switch-input duplicaterecipients"
                            />
                            <div class="switch-slider"></div> </label
                          >&nbsp;&nbsp;
                          <span style="font-size: 18px"
                            >Duplica i destinatari</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelNewEmail"
                        >
                          {{ cancel }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="confirmSaveDuplicateNewsletter(rowIdSelected)"
                        >
                          {{ duplicate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- tabAdminNewsletterPopupDuplicate -->
          <!--popup detailviewlistmailerror -->
          <div
            class="modal"
            id="detailviewlistmailerror"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg" role="document" style="max-width: 90%!important;">
              <div class="modal-content padding" style="min-height: 94vh;">
                <div class="modal-header text-center">
                  <h2 class="modal-title w-100 font-weight-bold" style="color:#73818f!important;">
                    Lista Email in Errore
                  </h2>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                  <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                   <div class="modal-body mx-12" style="overflow: auto;height: 84vh;padding: 30px;">
                  <div class="md-form mb-12">
                     <div
                          v-for="ListEmailErrors in ListEmailError"
                          v-bind:key="ListEmailErrors"
                        >
                      <div class="row" style="max-height: 84vh;overflow: auto;">
                       <div class="col-2"><strong class="text-muted font-weight-bold small" style="font-size: 16px">Nome</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ListEmailErrors.name}}</label></div>
                       <div class="col-2"><strong class="text-muted font-weight-bold small" style="font-size: 16px">Cognome</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ListEmailErrors.surname}}</label></div>
                       <div class="col-3"><strong class="text-muted font-weight-bold small" style="font-size: 16px">Email</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ListEmailErrors.email}}</label></div>
                       <div class="col-1"  v-if="ListEmailErrors.send_newsletter == true">
                         <strong class="text-muted font-weight-bold small" style="font-size: 16px">Disiscritto</strong><br>
                         <i class="fa fa-check" aria-hidden="true" style="color:green!important;font-size: 25px;"></i>
                       </div>
                        <div class="col-1" v-else>
                         <strong class="text-muted font-weight-bold small" style="font-size: 16px">Disiscritto</strong><br>
                         <i class="fa fa-times" aria-hidden="true" style="color:red!important;font-size: 25px;" ></i>
                       </div>
                         <div class="col-2"  v-if="ListEmailErrors.updated_email == true">
                         <strong class="text-muted font-weight-bold small" style="font-size: 16px">Modificato</strong><br>
                         <i class="fa fa-check" aria-hidden="true" style="color:green!important;font-size: 25px;"></i>
                       </div>
                        <div class="col-2" v-else>
                         <strong class="text-muted font-weight-bold small" style="font-size: 16px">Modificato</strong><br>
                         <i class="fa fa-times" aria-hidden="true" style="color:red!important;font-size: 25px;" ></i>
                       </div>
                       <div class="col-2">
                         <button class="btn btn-danger" 
                       @click="unsubscribefornewsletter(ListEmailErrors.newsletter_recipient_id,ListEmailErrors.send_newsletter)">
                       <i class="fa fa-trash" style="color:#fff!important;"></i>
                       </button>
                       <div v-if="ListEmailErrors.updated_email == false">
                      <button class="btn btn-success"
                       @click="updateViewEmailNewsletter(ListEmailErrors.newsletter_recipient_id,ListEmailErrors.send_newsletter,ListEmailErrors.email)">
                       <i class="fa fa-pencil-square" style="color:#fff!important;"></i></button>
                       </div>
                       <div v-else>
                      <button class="btn btn-success" id="buttonsaveemailnewsletter" disabled>
                       <i class="fa fa-pencil-square" style="color:#fff!important;"></i></button>
                       </div>                    
                       </div>
                    </div>
                       <hr>
                        </div>
                  </div>
                   <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="unsubscribeallfornewsletter()">
                            Clicca per disiscrivere tutte le email!
                        </button>
                       </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end popup detailviewlistmailerror -->

          <!--popup detailviewlistmailopen -->
          <div
            class="modal"
            id="detailviewlistmailopen"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg" role="document" style="max-width: 90%!important;">
              <div class="modal-content padding" style="min-height: 94vh;">
                <div class="modal-header text-center">
                  <h2 class="modal-title w-100 font-weight-bold" style="color:#73818f!important;">
                    Dettaglio Email Aperte
                  </h2>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                  <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                   <div class="modal-body mx-12" style="overflow: auto;height: 84vh;padding: 30px;">
                  <div class="md-form mb-12">
                     <div
                          v-for="ListEmailOpens in ListEmailOpen"
                          v-bind:key="ListEmailOpens"
                        >
                      <div class="row" style="max-height: 84vh;overflow: auto;">
                       <div class="col-2">
                         
                       </div>
                       <div class="col-2"><strong class="text-muted font-weight-bold small" style="font-size: 16px">Cognome</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ListEmailOpens.surname}}</label></div>
                       <div class="col-3"><strong class="text-muted font-weight-bold small" style="font-size: 16px">Email</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ListEmailOpens.email}}</label></div>
                      <div class="col-3"><strong class="text-muted font-weight-bold small" style="font-size: 16px">Data Apertura</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ListEmailOpens.created_at}}</label></div>
                       <div class="col-2"><strong class="text-muted font-weight-bold small" style="font-size: 16px">Aperta</strong><br>
                       <label class="text-muted font-weight-bold small" style="font-size: 14px">{{ListEmailOpens.cont}} volte</label></div>
                    </div>
                       <hr>
                        </div>
                  </div>
                   <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                        ><i class="fa fa-times" aria-hidden="true"></i>
                        Indietro
                        </button>
                       </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end popup detailviewlistmailopen -->
          <!--popup detailupdateEmailNewsletter -->
          <div
            class="modal"
            id="detailupdateEmailNewsletter"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg" role="document" style="max-width: 90%!important;">
              <div class="modal-content padding" style="min-height: 94vh;">
                <div class="modal-header text-center">
                  <h2 class="modal-title w-100 font-weight-bold" style="color:#73818f!important;">
                    Modifica Email 
                  </h2>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                   <div class="modal-body mx-12" style="overflow: auto;height: 84vh;padding: 30px;">
                  <div class="md-form mb-12">
                  <div class="row">
                  <div class="col-8">
                    <input type="text" class="form-control" id="emailupdnewsletter" name="emailupdnewsletter">
                     <input type="hidden" class="form-control" id="newsletter_recipient_id" name="newsletter_recipient_id">
                  </div>
                  <div class="col-4">
                     <button
                        type="button"
                        class="btn btn-success"
                         @click="updateemailnewsletter()">
                        <i class="fa fa-floppy" aria-hidden="true"></i>
                        Salva
                      </button>
                  </div>
                  </div>
                  </div>
                   <div class="col-12 text-right">
                        <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                        ><i class="fa fa-times" aria-hidden="true"></i>
                        Indietro
                        </button>
                       </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end popup detailupdateEmailNewsletter -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import Graphic from "@/components/Graphic.vue";
export default {
  name: "AdminNewsletterCampaign1",
  components: {
    BootstrapTable,
    PageDetail,
    Graphic,
  },
  data: function () {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      crm: dictionaryHelpers.getDictionary("CRM"),
      postalcode: dictionaryHelpers.getDictionary("PostalCode"),
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      charts: [],
      chartsres: [],
      chartsrestime: [],
      ListEmailError: [],
      ListEmailOpen: [],
      chartsResult: {},
      chartsResultGraphic: {},
      detailConfiguration: [],
      detailData: { html: "" },
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newCustomer: dictionaryHelpers.getDictionary("NewCustomer"),
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      save: "Salva Campagna",
      duplicate: "Duplica Campagna",
      send: "",
      TableConfiguration: [],
      DetailHtmlConfiguration: [],
      tableData: [],
      tableResult: [],
      titleDetail: null,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname,
      rowIdSelected: 0,
      selected:0,
      sending_duration:0,
      sommaorafinestimata: 0,
      length: 0,
      emailuser: 0,
      cont: 0,
      rowsSelected: 0,
      configDateTime: {
        format: storageData.sDateTimePickerFormat(),
        minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
        useCurrent: true,
        showClear: true,
        showClose: true,
      },
      CheckCheckedAlls: false,
      listEmail: [],
      listNewsletterGroupQueryEmail: [],
      listData: 0,
      listNumberDetailSend: [],
      listEmailGroupDetailSend: [],
      titleDetailSend: "",
      msgDetailSend: "",
      dataDetailSend: "",
      draftresult: true,
      TokenTinyUrl: "",
     
    };
  },
  created() {
    var AdminNewsletterCampaign1 = this;
    settingServices.getByCode("TokenAPITinyurl", function (result) {
      if (
        functionHelpers.isValued(result.message) &&
        functionHelpers.isValued(result.message)
      ) {
        AdminNewsletterCampaign1.TokenTinyUrl = result.message;
      } else {
        notificationHelpers.warning(
          "Token per conversione URL non inserito!<br> Inserirlo nelle gestione Impostazioni."
        );
      }
    });
    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function (result) {
      if (
        functionHelpers.isValued(result) &&
        functionHelpers.isValued(result.data)
      ) {
        AdminNewsletterCampaign1.TableConfiguration =
          result.data.tablesConfigurations[0].tablesConfigurations;
        AdminNewsletterCampaign1.DetailHtmlConfiguration =
          result.data.tabsConfigurations[0].pageConfigurations;
      }
      AdminNewsletterCampaign1.loadTable();
    });
  },
  methods: {
    previewClick() {
      window.open($("#url").val());
    },

    previewClickView(id) {
      var AdminNewsletterCampaign1 = this;
      this.rowIdSelected = id;

      newsletterServices.getByListDateForId(
        AdminNewsletterCampaign1.rowIdSelected,
        function (result) {
          window.open(result.data[0].url);
        }
      );
    },

    loadTable() {
      var AdminNewsletterCampaign1 = this;
      newsletterServices.getAllCampaign(function (result) {
        AdminNewsletterCampaign1.tableData = result.data;
        spinnerHelpers.hide();
      });   
    },

    writebtnsendemailtest() {
      var AdminNewsletterCampaign1 = this;
      var send = $("#sender_email").val();
      AdminNewsletterCampaign1.send = send;
    },

    formatCopyUrlShort() {
      var AdminNewsletterCampaign1 = this;
      var longUrl = $("#original_url").val();
      var shorturl = $("#short-url").val();
      if (functionHelpers.isValued(longUrl)) {
        var settings = {
          url:
            "https://api.tinyurl.com/create?url=" +
            longUrl +
            "&domain=tiny.one",
          method: "POST",
          timeout: 0,
          headers: {
            Authorization: "Bearer " + AdminNewsletterCampaign1.TokenTinyUrl,
          },
        };
        $.ajax(settings).done(function (response) {
          if (functionHelpers.isValued(response.data.tiny_url)) {
            spinnerHelpers.hide();
            $("#short-url").html(response.data.tiny_url);
            var p1 = response.data.tiny_url;
            var hiddenField = document.getElementById("copyText");
            hiddenField.value = p1;
            hiddenField.select();
            document.execCommand("copy");
            alert(hiddenField.value + " Copiato");

            /*
          $('#short-url').html(response.data.tiny_url);
          var p1 = response.data.tiny_url;
          //var hiddenField = document.getElementById("copyText");
          var hiddenField = $("#short-url").html();
          hiddenField = p1;
          //document.getElementById("copyText");
         // hiddenField.value = p1;
          //hiddenField.select();
          document.execCommand("copy");
          //document.execCommand("copy");
          alert(hiddenField + " Copiato"); 
         // alert(hiddenField.value + " Copiato"); 
          */
          }
        });
      }
    },

    formatTinyUrl() {
      spinnerHelpers.show();
      var AdminNewsletterCampaign1 = this;
      var longUrl = $("#original_url").val();
      var shorturl = $("#short-url").val();
      if (functionHelpers.isValued(longUrl)) {
        var settings = {
          url:
            "https://api.tinyurl.com/create?url=" +
            longUrl +
            "&domain=tiny.one",
          method: "POST",
          timeout: 0,
          headers: {
            Authorization: "Bearer " + AdminNewsletterCampaign1.TokenTinyUrl,
          },
        };

        $.ajax(settings).done(function (response) {
          if (functionHelpers.isValued(response.data.tiny_url)) {
            spinnerHelpers.hide();
            $("#short-url").html(response.data.tiny_url);
            $("#btncopyshorturl").show();
            /*var p1 = response.data.tiny_url;
          var hiddenField = document.getElementById("copyText");
          hiddenField.value = p1;
          hiddenField.select();
          document.execCommand("copy");
          alert(hiddenField.value + "Copiato" );   */
          } else {
            spinnerHelpers.hide();
            //$('#btncopyshorturl').hide();
            notificationHelpers.error(
              "Ops qualcosa è andato in errore, riprovare più tardi!"
            );
          }
        });
      } else {
        spinnerHelpers.hide();
        notificationHelpers.warning(
          "Url originale non inserito correttamente!"
        );
      }
    },

    CheckNewsletterFormatter(value, row, index, field) {
      var AdminNewsletterCampaign1 = this;


     /* for (var i = 0; i < AdminNewsletterCampaign1.tableData.length; i++) {
     
         if (AdminNewsletterCampaign1.tableData[i].end_send_date_time != "" && AdminNewsletterCampaign1.tableData[i].end_send_date_time != "-" && 
         AdminNewsletterCampaign1.tableData[i].end_send_date_time != null) {
          var html =
          '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="draft" class="switch-input" checked="checked" disabled="disabled" onclick="AdminNewsletterCampaign1.__vue__.onChangeCheckOnlineNewsletter(' +
          row.id +
          ')"><span class="switch-slider" data-on data-off></span></label></div>';
             } 
      }*/


      if (row.draft) {
        var html =
          '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="draft" class="switch-input" checked="checked" onclick="AdminNewsletterCampaign1.__vue__.onChangeCheckOnlineNewsletter(' +
          row.id +
          ')"><span class="switch-slider" data-on data-off></span></label></div>';
      } else {
        var html =
          '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="draft" class="switch-input" onclick="AdminNewsletterCampaign1.__vue__.onChangeCheckOnlineNewsletter(' +
          row.id +
          ')"><span class="switch-slider" data-on data-off></span></label></div>';
      }

       if (row.end_send_date_time != "" && row.end_send_date_time != "-") {
        var html =
          '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="draft" class="switch-input" disabled="disabled" onclick="AdminNewsletterCampaign1.__vue__.onChangeCheckOnlineNewsletter(' +
          row.id +
          ')"><span class="switch-slider" data-on data-off></span></label></div>';
      } 

      return html;
    },

    newsletterFormatter(value, row, index, field) {
      var AdminNewsletterCampaign1 = this;
      var html =
        '<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      if (row.end_send_date_time != "" && row.end_send_date_time != "-") {
        html +=
          '<button class="btn btn-warning" onclick="AdminNewsletterCampaign1.__vue__.executeOpenDetail(' +
          row.id +
          ')"><i class="fa fa-eye" style="color:#fff;" title="' +
          this.openDetail +
          '" /></button>';
      } else {
        html +=
          '<button class="btn btn-success" onclick="AdminNewsletterCampaign1.__vue__.executeOpenDetail(' +
          row.id +
          ')"><i class="fa fa-pencil" style="color:#fff;" title="' +
          this.openDetail +
          '" /></button>';
      }
      html +=
        '<button class="btn btn-secondary" onclick="AdminNewsletterCampaign1.__vue__.previewClickView(' +
        row.id +
        ')"><i class="fa fa-search" style="color:#fff;"/></button>';

      html +=
        '<button class="btn btn-info" onclick="AdminNewsletterCampaign1.__vue__.executeduplicate(' +
        row.id +
        ')"><i class="fa fa-copy" style="color:#fff;" title="' +
        '" /></button>';
      if (row.end_send_date_time != "" && row.end_send_date_time != "-") {
        html +=
          '<button class="btn btn-primary" onclick="AdminNewsletterCampaign1.__vue__.feedback(' +
          row.id +
          ')"><i class="fa fa-list" style="color:#fff;"/></button></div></div>';
      } else {
        html += "<div>" + "</div>";
      }
      return html;
    },

    deletenewsletterFormatter(value, row, index, field) {
      var AdminNewsletterCampaign1 = this;
      var html =
        '<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      if (
        row.end_send_date_time == "" ||
        row.end_send_date_time == "-" ||
        row.end_send_date_time == null
      ) {
        html +=
          '<button class="btn btn-danger" onclick="AdminNewsletterCampaign1.__vue__.delete(' +
          row.id +
          ')"><i class="fa fa-trash" style="color:#fff;"/></button></div></div>';
      } else {
        html += "<div>" + "</div>";
      }
      return html;
    },

    delete(id) {
      var AdminNewsletterCampaign1 = this;
      spinnerHelpers.show();
      newsletterServices.del(id, function () {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );
        AdminNewsletterCampaign1.loadTable();
        window.scrollTo(0, 0);
      });
    },

    onChangeCheckOnlineNewsletter(id) {
      var AdminNewsletterCampaign1 = this;
      var data = {
        id: id,
      };
      newsletterServices.updateOnlineNewsletterCheck(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
    },

    executeOpenDetail(id) {
      spinnerHelpers.show();
      var AdminNewsletterCampaign1 = this;
      this.rowIdSelected = id;
      this.titleDetail = this.customer;
      $.each(this.tableData, function (i, row) {
        if (AdminNewsletterCampaign1.rowIdSelected == row.id) {
          AdminNewsletterCampaign1.detailData = row;
        }
      });

      newsletterServices.getByListDateForId(
        AdminNewsletterCampaign1.rowIdSelected,
        function (result) {
          AdminNewsletterCampaign1.listEmail = result.data[0].listEmail;
          $("#title").val(result.data[0].title);
          $("#schedule_date_time").val(result.data[0].schedule_date_time);
          AdminNewsletterCampaign1.draftresult = result.data[0].draft;
          $("#sender").val(result.data[0].sender);
          $("#sender_email").val(result.data[0].sender_email);
          $("#object").val(result.data[0].object);
          $("#preview_object").val(result.data[0].preview_object);
          $("#url").val(result.data[0].url);
          AdminNewsletterCampaign1.detailData.html = result.data[0].html;
          AdminNewsletterCampaign1.detailData.group = result.data[0].group;
          var send = result.data[0].sender_email;
          AdminNewsletterCampaign1.send = send;
          var sending_duration = result.data[0].sending_duration;
          AdminNewsletterCampaign1.sending_duration = sending_duration;
          var sommaorafinestimata = result.data[0].sommaorafinestimata;
          AdminNewsletterCampaign1.sommaorafinestimata = sommaorafinestimata;

          if (
            result.data[0].endSendDateTime != "" &&
            result.data[0].endSendDateTime != "-" &&
            result.data[0].endSendDateTime != null
          ) {
            $("#title").prop("disabled", true);
            $("#schedule_date_time").prop("disabled", true);
            document.getElementById("coldraft1").style.display = "none";
            $("#sender").prop("disabled", true);
            $("#sender_email").prop("disabled", true);
            $("#object").prop("disabled", true);
            $("#preview_object").prop("disabled", true);
            $("#original_url").prop("disabled", true);
            $("#url").prop("disabled", true);
            

            $("#btnsave").hide();
          } else {
            $("#title").prop("disabled", false);
            $("#schedule_date_time").prop("disabled", false);
            document.getElementById("coldraft1").style.display = "block";
            $("#sender").prop("disabled", false);
            $("#sender_email").prop("disabled", false);
            $("#object").prop("disabled", false);
            $("#preview_object").prop("disabled", false);
            $("#original_url").prop("disabled", false);
            $("#url").prop("disabled", false);
            $("#btnsave").show();
          }

          AdminNewsletterCampaign1.listData =
            AdminNewsletterCampaign1.listEmail.length;
          spinnerHelpers.hide();
        }
      );
      $("#btncopyshorturl").hide();
      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();
    },

    executeduplicate: function (id) {
      $("#tabAdminNewsletterPopupDuplicate").modal("show");
      var AdminNewsletterCampaign1 = this;
      AdminNewsletterCampaign1.rowIdSelected = id;
    },

    feedback: function (id) {
      $("#tabAdminNewsletterResocontoList").modal("show");
  
      var AdminNewsletterCampaign1 = this;
      AdminNewsletterCampaign1.rowIdSelected = id;

      this.charts = [];
      $.each(this.tableData, function (i, row) {
        if (AdminNewsletterCampaign1.rowIdSelected == row.id) {
          AdminNewsletterCampaign1.rowIdSelected = row.id;
        }
      });
      feedbackNewsletterServices.getChart(id, function (result) {
          AdminNewsletterCampaign1.chartsResult = result.data;
          $.each(
            AdminNewsletterCampaign1.chartsResult.charts,
            function (i, chart) {
              AdminNewsletterCampaign1.charts.push({
                title: chart.labels[1],
                idCont: "chart_" + i,
                confGrafic: {
                  type: "pie",
                  data: {
                    labels: chart.labels,
                    datasets: [
                      {
                        backgroundColor: chart.datasets[0].backgroundColor,
                        data: chart.datasets[0].data,
                      },
                    ],
                  },
                  options: {
                    legend: { display: false },
                    animation: { animateRotate: false, animateScale: true },
                    scales: {
                      xAxes: [
                        {
                          gridLines: { display: false },
                          ticks: { display: false },
                        },
                      ],
                      yAxes: [
                        {
                          gridLines: { display: false },
                          ticks: { display: false },
                        },
                      ],
                    },
                  },
                },
              });
              // }
              spinnerHelpers.hide();
            }
          );
        }
      );

      /* graphic lines for date;*/
      this.chartsres = [];
      feedbackNewsletterServices.getChartGraphics(id,function (result) {
          AdminNewsletterCampaign1.chartsResultGraphic = result.data;
          $.each(AdminNewsletterCampaign1.chartsResultGraphic.chartsres,
            function (i, charty) {              
              AdminNewsletterCampaign1.chartsres.push({
                title:'Statistiche Giornaliere',
                idCont: "chart_4",
                confGrafic: {
                  
                  type: "line",
                  data: {
                    labels: charty.labels,
                    datasets: [                   
                      {
                        backgroundColor: charty.datasets[0].backgroundColor,
                        borderColor: charty.datasets[0].borderColor,
                        data: charty.datasets[0].data,
                       
                      },
                    ],
                  },
                  options: {
                    legend: { display: false },
                    title: {
                      display: true,
                    },

                    animation: { animateRotate: false, animateScale: false },
                    scales: {
                      xAxes: [
                        {
                          gridLines: { display: true },
                          ticks: { display: true },
                        },
                      ],
                      yAxes: [
                        {
                          gridLines: { display: true },
                          ticks: { display: true },
                        },
                      ],
                    },
                  },
                },
              });
              spinnerHelpers.hide();
            }
          );
        }
      );
      /* graphic lines for date; */

        /* graphic lines for date;*/

      this.chartsrestime = [];
      feedbackNewsletterServices.getChartGraphicsforTime(id, function (result) {
          AdminNewsletterCampaign1.chartsResultGraphic = result.data;
          $.each(AdminNewsletterCampaign1.chartsResultGraphic.chartsrestime,
            function (i, charttime) {              
              AdminNewsletterCampaign1.chartsrestime.push({
                title:'Statistiche Orarie',
                idCont: "chart_5",
                confGrafic: {            
                  type: "line",
                  data: { 
                    labels: charttime.labels,
                    datasets: [                   
                      {
                        backgroundColor: charttime.datasets[0].backgroundColor,
                        borderColor: charttime.datasets[0].borderColor,
                        data: charttime.datasets[0].data,
                      },
                    ],
                  },
                  options: {
                    legend: { display: false },
                    title: {
                      display: true,
                    },

                    animation: { animateRotate: false, animateScale: false },
                    scales: {
                      xAxes: [
                        {
                          gridLines: { display: true },
                          ticks: { display: true },
                        },
                      ],
                      yAxes: [
                       
                        {
                          
                          gridLines: { display: true },
                          ticks: { display: true },
                          
                        },
                      ],
                    },
                  },
                },
              });
              spinnerHelpers.hide();
            }
          );
        }
      );
      /* graphic lines for date; */

      // ----------END SECTION FEEDBACK ---------- //
    },

    ontabAdminGroupContactEmail: function () {
      var AdminNewsletterCampaign1 = this;
      $.getScript(
        "https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js"
      ).done(function () {
        var searchParam = "";
        $("#groupEmail").select2({
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/groupSms/select",
            data: function (params) {
              if (params.term == "") {
                searchParam = "*";
              } else {
                searchParam = params.term;
              }
              var query = {
                search: searchParam,
              };
              return query;
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);
              return {
                results: dataParse.data,
              };
            },
          },
        });
      });
      $("#groupEmail").on("change", function () {
        var id = $(this).val();
        //funzione per prelievo lista contatti con il gruppo selezionato
        newsletterServices.getListEmailByGroup(id, function (response) {
          AdminNewsletterCampaign1.listEmailGroupDetailSend = [];
          if (response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              var data = {
                email: response.data[i].email,
                id: i
              }
              /*AdminNewsletterCampaign1.listEmailGroupDetailSend.push(
                response.data[i].email
              );*/
              data
              AdminNewsletterCampaign1.listEmailGroupDetailSend.push(data);
            }
          } else {
            notificationHelpers.warning("Nessuna Email presente nel gruppo!");
          }
        });
      });

      $.getScript(
        "https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js"
      ).done(function () {
        var searchParam = "";
        $("#groupEmailQueryGroup").select2({
          ajax: {
            url:
              configData.wsRootServicesUrl +
              "/api/v1/querygroupnewsletter/select",
            data: function (params) {
              if (params.term == "") {
                searchParam = "*";
              } else {
                searchParam = params.term;
              }
              var query = {
                search: searchParam,
              };
              return query;
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);
              return {
                results: dataParse.data,
              };
            },
          },
        });
      });

      $("#groupEmailQueryGroup").on("change", function () {
        var id = $(this).val();
        //funzione prelievo da lista query gruppi newsletter
        newsletterServices.getListEmailQueryGroupNewsletter(
          id,
          function (response) {
            AdminNewsletterCampaign1.listNewsletterGroupQueryEmail = [];
            if (response.data.length > 0) {
              for (var i = 0; i < response.data.length; i++) {
                AdminNewsletterCampaign1.listNewsletterGroupQueryEmail.push(
                  response.data[i].email
                );
              }
            } else {
              notificationHelpers.warning("Nessuna Email presente!");
            }
          }
        );
      });
      $("#detailGroupContactClient").addClass("active");
      $("#detailContactClient").removeClass("active");
      $("#detailMassiveEmail").removeClass("active");
      $("#detailSingleEmail").removeClass("active");
    },

    addEmailGroupContactToList: function () {
      var AdminNewsletterCampaign1 = this;

    /*  for (var i = 0;i < AdminNewsletterCampaign1.listEmailGroupDetailSend.length; i++) {
        var check = AdminNewsletterCampaign1.listEmail.includes(
          AdminNewsletterCampaign1.listEmailGroupDetailSend[i]
        );
        if (!check) {
          AdminNewsletterCampaign1.listEmail.push({
            email: AdminNewsletterCampaign1.listEmailGroupDetailSend[i],
            visible: true,
            group: "ListeGruppi",
            checked: false,
          });
        } else {
          notificationHelpers.warning(
            "Email " +
              AdminNewsletterCampaign1.listEmailGroupDetailSend[i] +
              " già presente nella lista!"
          );
        }
      }*/
      var arraydetailGroupQuery = AdminNewsletterCampaign1.listEmailGroupDetailSend;
        for(var i = 0;i<arraydetailGroupQuery.length;i++){
     
          var check = false;
          for(var j = 0; j < AdminNewsletterCampaign1.listEmail.length; j++) {
              var obj = AdminNewsletterCampaign1.listEmail[j].email;
            if(obj == arraydetailGroupQuery[i].email){ 
              check=true; 
              break;
            }   
          }
          if (check){
            notificationHelpers.warning("Email " + arraydetailGroupQuery[i].email + " già presente nella lista!");
          }else{
              AdminNewsletterCampaign1.listEmail.push({email:arraydetailGroupQuery[i].email, visible:true, group: "ListeGruppi", checked: false});
          }
       }

   /*   for (var i = 0; i < AdminNewsletterCampaign1.listNewsletterGroupQueryEmail.length; i++) {
      console.log(AdminNewsletterCampaign1.listNewsletterGroupQueryEmail);    
        var check = AdminNewsletterCampaign1.listEmail.includes(AdminNewsletterCampaign1.listNewsletterGroupQueryEmail[i]);
        console.log(AdminNewsletterCampaign1.listEmail);
        if (!check) {
          AdminNewsletterCampaign1.listEmail.push({ email: AdminNewsletterCampaign1.listNewsletterGroupQueryEmail[i],
            visible: true,
            group: "ListeQueryGruppi",
            checked: false,
          });
        } else {
          notificationHelpers.warning("Email " + AdminNewsletterCampaign1.listNewsletterGroupQueryEmail[i] + " già presente nella lista!");
        }
      }*/

     var arrayEmailGroupQuery = AdminNewsletterCampaign1.listNewsletterGroupQueryEmail;
        for(var i = 0;i<arrayEmailGroupQuery.length;i++){
     
          var check = false;
          for(var j = 0; j < AdminNewsletterCampaign1.listEmail.length; j++) {
              var obj = AdminNewsletterCampaign1.listEmail[j].email;
            if(obj == arrayEmailGroupQuery[i]){ 
              check=true; 
              break;
            }   
          }
          if (check){
            notificationHelpers.warning("Email " + arrayEmailGroupQuery[i] + " già presente nella lista!");
          }else{
              AdminNewsletterCampaign1.listEmail.push({email:arrayEmailGroupQuery[i], visible:true, group: "ListeQueryGruppi", checked: false});
          }
       }


      this.listData = 0;
      AdminNewsletterCampaign1.listData =
        AdminNewsletterCampaign1.listEmail.length;
    },

    ontabAdminContactEmail: function () {
      var AdminNewsletterCampaign1 = this;
      $.getScript(
        "https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js"
      ).done(function () {
        var searchParam = "";
        $("#user_id").select2({
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/contact/select",
            data: function (params) {
              if (params.term == "") {
                searchParam = "*";
              } else {
                searchParam = params.term;
              }
              var query = {
                search: searchParam,
              };
              return query;
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);
              return {
                results: dataParse.data,
              };
            },
          },
        });

        var searchParam = "";
        $("#user_id_users").select2({
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/user/selectUserPages",
            data: function (params) {
              if (params.term == "") {
                searchParam = "*";
              } else {
                searchParam = params.term;
              }
              var query = {
                search: searchParam,
              };
              return query;
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);
              return {
                results: dataParse.data,
              };
            },
          },
        });
      });
      $("#user_id").on("change", function () {
        var id = $(this).val();
        newsletterServices.getemail(id, function (response) {
          $("#email_select_contact").val(response.data.email_select_contact);
        });
      });

      $("#user_id_users").on("change", function () {
        var id = $(this).val();
        newsletterServices.getemailusers(id, function (response) {
          $("#emailuser_select_contact").val(
            response.data.emailuser_select_contact
          );
        });
      });
      $("#detailContactClient").addClass("active");
      $("#detailGroupContactClient").removeClass("active");
      $("#detailMassiveEmail").removeClass("active");
      $("#detailSingleEmail").removeClass("active");
    },

    addEmailContactToList: function () {
      var AdminNewsletterCampaign1 = this;

      var email = $("#email_select_contact").val().trim().replace(" ", "");
      var email_valid =
        /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-]{2,}))+.([a-zA-Z0-9]{2,})+$/;

      if (!email_valid.test(email) || email == "" || email == "undefined") {
        alert("Devi inserire L'indirizzo mail corretto");
        document.email.focus();
        return false;
      }

        if(functionHelpers.isValued(email)){
        var arrayEmail = email.split("\n");
        for(var i = 0;i<arrayEmail.length;i++){

          var check = false;
          for(var j = 0; j < AdminNewsletterCampaign1.listEmail.length; j++) {
              var obj = AdminNewsletterCampaign1.listEmail[j].email;
            if(obj == arrayEmail[i]){ 
              check=true; 
              break;
            }   
          }
          if (check){
            notificationHelpers.warning("Email " + arrayEmail[i] + " già presente nella lista!");
          }else{
            AdminNewsletterCampaign1.listEmail.push({email: email, visible:true, group: "ListaContatti", checked: false});
          }
       }
      }
      $("#email_select_contact").html('');
  

      // ------------------------------------------------------------------------------------------------------------------ //
      var emailuser = $("#emailuser_select_contact")
        .val()
        .trim()
        .replace(" ", "");
      var email_valid =
        /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-]{2,}))+.([a-zA-Z0-9]{2,})+$/;
      if (
        !email_valid.test(emailuser) ||
        emailuser == "" ||
        emailuser == "undefined"
      ) {
        alert("Devi inserire L'indirizzo mail corretto");
        document.emailuser.focus();
        return false;
      }

       if(functionHelpers.isValued(emailuser)){
        var arrayEmailUser = emailuser.split("\n");
        for(var i = 0;i<arrayEmailUser.length;i++){
          var check = false;
          for(var j = 0; j < AdminNewsletterCampaign1.listEmail.length; j++) {
              var obj = AdminNewsletterCampaign1.listEmail[j].email;
            if(obj == arrayEmailUser[i]){ 
              check=true; 
              break;
            }   
          }
          if (check){
            notificationHelpers.warning("Email " + arrayEmailUser[i] + " già presente nella lista!");
          }else{
            AdminNewsletterCampaign1.listEmail.push({email: emailuser, visible:true, group: "ListaUtenti", checked: false});
          }
       }
      }
       $("#emailuser_select_contact").html('');


      this.listData = 0;
      AdminNewsletterCampaign1.listData =
        AdminNewsletterCampaign1.listEmail.length;
      $("#email_select_contact").val("");
      $("#emailuser_select_contact").val("");
    },


    onclickviewlistmailerror: function () {
      var AdminNewsletterCampaign1 = this;

      newsletterServices.getAllviewlistmailerror(AdminNewsletterCampaign1.chartsResult.idNewsletter, function (result) {
      AdminNewsletterCampaign1.ListEmailError = result.data[0].ListEmailError;
        spinnerHelpers.hide();
        $("#detailviewlistmailerror").modal("show"); 
      });
    },

    onclickviewlistmailopen: function () {
      var AdminNewsletterCampaign1 = this;
      newsletterServices.getAllviewlistmailopen(AdminNewsletterCampaign1.chartsResult.idNewsletter, function (result) {
        AdminNewsletterCampaign1.ListEmailOpen = result.data[0].ListEmailOpen;
        spinnerHelpers.hide();
        $("#detailviewlistmailopen").modal("show");
      });
    },

    updateViewEmailNewsletter: function(newsletter_recipient_id,send_newsletter,email){
      var AdminNewsletterCampaign1 = this;

      $("#emailupdnewsletter").val(email);
      $("#newsletter_recipient_id").val(newsletter_recipient_id);
      $("#detailupdateEmailNewsletter").modal("show");
    },

     updateemailnewsletter() {
       if (confirm("Sei sicuro di voler eseguire il salvataggio?")) {
        this.executeupdateemailnewsletter();
      }
    },

    executeupdateemailnewsletter() {
      var AdminNewsletterCampaign1 = this;
       var data = {
          email: $("#emailupdnewsletter").val(),
          newsletter_recipient_id:$("#newsletter_recipient_id").val(),
        };
        newsletterServices.updateemailnewsletter(data, function (result) {
        notificationHelpers.success("Modifica avvenuta correttamente"); 
        AdminNewsletterCampaign1.ListEmailError = [];
          newsletterServices.getAllviewlistmailerror(AdminNewsletterCampaign1.chartsResult.idNewsletter, function (result) {
            AdminNewsletterCampaign1.ListEmailError = result.data[0].ListEmailError;
          });
      });
    },



    unsubscribefornewsletter(newsletter_recipient_id,send_newsletter) {
      var AdminNewsletterCampaign1 = this;
        var data = {
          newsletter_recipient_id: newsletter_recipient_id,
          id: this.rowIdSelected
        };

      if (send_newsletter == true){
       if (confirm("Sei sicuro di voler eseguire la disiscrizione?")) {  
        newsletterServices.unsubscribefornewsletter(data, function (result) {
          notificationHelpers.success("Disiscrizione contatto avvenuta correttamente");
          AdminNewsletterCampaign1.ListEmailError = [];
          newsletterServices.getAllviewlistmailerror(AdminNewsletterCampaign1.chartsResult.idNewsletter, function (result) {
            AdminNewsletterCampaign1.ListEmailError = result.data[0].ListEmailError;
            spinnerHelpers.hide();
          });
        });
       }
      }else{
          notificationHelpers.error("Attenzione, non puoi eseguire la disiscrizione del contatto poichè risulta già disiscritto!");
      }
    },

     unsubscribeallfornewsletter() {
       if (confirm("Sei sicuro di voler eseguire la disiscrizione di tutti i contatti?")) {
        this.executeunsubscribeallfornewsletter();
      }
    },

     executeunsubscribeallfornewsletter() {
      var AdminNewsletterCampaign1 = this;
    
       var data = {
          id:AdminNewsletterCampaign1.chartsResult.idNewsletter
        };

        newsletterServices.unsubscribeallfornewsletter(data, function (result) {
        notificationHelpers.success("Disiscrizione contatti avvenuta correttamente"); 
        AdminNewsletterCampaign1.ListEmailError = [];
          newsletterServices.getAllviewlistmailerror(AdminNewsletterCampaign1.chartsResult.idNewsletter, function (result) {
            AdminNewsletterCampaign1.ListEmailError = result.data[0].ListEmailError;
          });
      });
    },

    ontabAdminEmail: function () {
      $("#detailContactClient").removeClass("active");
      $("#detailGroupContactClient").removeClass("active");
      $("#detailMassiveEmail").removeClass("active");
      $("#detailSingleEmail").addClass("active");
    },
    ontabAdminMassiveEmail: function () {
      $("#detailContactClient").removeClass("active");
      $("#detailGroupContactClient").removeClass("active");
      $("#detailMassiveEmail").addClass("active");
      $("#detailSingleEmail").removeClass("active");
    },

    onNewCampaign() {
      var AdminNewsletterCampaign1 = this;


      spinnerHelpers.show();
      this.detailData = { html: "" };
      AdminNewsletterCampaign1.listEmail = [];
      AdminNewsletterCampaign1.detailData.group = "";
      AdminNewsletterCampaign1.send = "";
      AdminNewsletterCampaign1.sending_duration = "";
      AdminNewsletterCampaign1.sommaorafinestimata = "";
      AdminNewsletterCampaign1.listData = [];
      $("#title").val("");
      $("#schedule_date_time").val("");

      $("#sender").val("");
      $("#sender_email").val("");
      $("#object").val("");
      $("#preview_object").val("");
      $("#url").val("");

      this.titleDetail = this.newCustomer;
      this.rowIdSelected = 0;
      $("#btncopyshorturl").hide();
      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();
    },

    addMailToList() {
      var AdminNewsletterCampaign1 = this;
      var email = $("#email").val().trim().replace(" ", "");

      var email_valid =
        /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-]{2,}))+.([a-zA-Z0-9]{2,})+$/;
      if (!email_valid.test(email) || email == "" || email == "undefined") {
        alert("Devi inserire L'indirizzo mail corretto");
        document.email.focus();
        return false;
      }

      var check = false;
      for (var i = 0; i < AdminNewsletterCampaign1.listEmail.length; i++) {
        var obj = AdminNewsletterCampaign1.listEmail[i].email;
        if (obj == email) {
          check = true;
          break;
        }
      }
      if (check) {
        notificationHelpers.warning(
          "Email " + email + " già presente nella lista!"
        );
      } else {
        AdminNewsletterCampaign1.listEmail.push({
          email: email,
          visible: true,
          group: "Singolo",
          checked: false,
        });
      }
      this.listData = 0;
      AdminNewsletterCampaign1.listData =
        AdminNewsletterCampaign1.listEmail.length;
      $("#email").val("");
    },

    onChangeCheckAll() {
      var AdminNewsletterCampaign1 = this;
      var isChecked = $("#CheckCheckedAll").is(":checked");

      for (var i = 0; i < AdminNewsletterCampaign1.listEmail.length; i++) {
        if (AdminNewsletterCampaign1.listEmail[i].visible) {
          if (isChecked) {
            AdminNewsletterCampaign1.listEmail[i].checked = true;
          } else {
            AdminNewsletterCampaign1.listEmail[i].checked = false;
          }
        } else {
          AdminNewsletterCampaign1.listEmail[i].checked = false;
        }
      }
    },

    delEmailListChecked() {
      var AdminNewsletterCampaign1 = this;

      for (var i = 0; i < AdminNewsletterCampaign1.listEmail.length; i++) {
        if (AdminNewsletterCampaign1.listEmail[i].checked) {
          AdminNewsletterCampaign1.listEmail =
            AdminNewsletterCampaign1.listEmail.filter(
              (e) => e === AdminNewsletterCampaign1.listEmail[i]
            );
        } else {
          notificationHelpers.warning(
            "Prima di procedere con l'eliminazione di tutti gli indirizzi email devi fleggare il check:seleziona tutto!"
          );
        }
      }
    },

    addEmailMassiveToList() {
      var AdminNewsletterCampaign1 = this;
      var massiveEmail = $("#email_massive").val();
      if (functionHelpers.isValued(massiveEmail)) {
        var arrayMassiveEmail = massiveEmail.split("\n");
        for (var i = 0; i < arrayMassiveEmail.length; i++) {
          var check = false;
          for (var j = 0; j < AdminNewsletterCampaign1.listEmail.length; j++) {
            var obj = AdminNewsletterCampaign1.listEmail[j].email;
            if (obj == arrayMassiveEmail[i]) {
              check = true;
              break;
            }
          }
          var email_valid =
            /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-]{2,})+.)+([a-zA-Z0-9]{2,})+$/;
          if (
            !email_valid.test(arrayMassiveEmail) ||
            arrayMassiveEmail == "" ||
            arrayMassiveEmail == "undefined"
          ) {
            alert("Devi inserire L'indirizzo mail corretto");
            document.massiveEmail.focus();
            return false;
          }
          if (check) {
            notificationHelpers.warning(
              "Email " + arrayMassiveEmail[i] + " già presente nella lista!"
            );
          } else {
            AdminNewsletterCampaign1.listEmail.push({
              email: arrayMassiveEmail[i],
              visible: true,
              group: "Massivo",
              checked: false,
            });
          }
        }
      } else {
        notificationHelpers.warning("Email non corretta!");
      }
      this.listData = 0;
      AdminNewsletterCampaign1.listData =
        AdminNewsletterCampaign1.listEmail.length;
      $("#email_massive").html("");
    },

    delEmailList(email) {
      var AdminNewsletterCampaign1 = this;
      AdminNewsletterCampaign1.listEmail =
        AdminNewsletterCampaign1.listEmail.filter((e) => e !== email);
      AdminNewsletterCampaign1.listData =
        AdminNewsletterCampaign1.listEmail.length;
    },

    ValueTextSender() {
      var c = document.getElementById("sender").value;
      document.getElementById("output").innerHTML = c.length;
      var sottr = 100 - c.length;
      document.getElementById("output_sottr_sender").innerHTML =
        "Caratteri rimanenti: " + sottr;
    },

    ValueTextSenderObject() {
      var c = document.getElementById("object").value;
      document.getElementById("output_object").innerHTML = c.length;
      var sottr = 150 - c.length;
      document.getElementById("object_sottr_object").innerHTML =
        "Caratteri rimanenti: " + sottr;
    },

    ValueTextPreviewObject() {
      var c = document.getElementById("preview_object").value;
      document.getElementById("output_preview_object").innerHTML = c.length;
      var sottr = 150 - c.length;
      document.getElementById("preview_sottr_object").innerHTML =
        "Caratteri rimanenti: " + sottr;
    },

    onTableCheckEmail() {
      var countRowSelected = this.$refs.tableCustomer.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

    confirmCancelNewEmail() {
      if (confirm("Confermi di voler tornare indietro?")) {
        this.executeCancelEmail();
      }
    },

    executeCancelEmail() {
      spinnerHelpers.show();
      this.detailTemplateEditorData = {};
      $("#tabTable").addClass("active");
      $("#tabDetail").removeClass("active");
      spinnerHelpers.hide();
    },

    Search() {
      var AdminNewsletterCampaign1 = this;
      var search = $("#search1").val();

      var tipology_search = $("#tipology_search").val();
      var res = search.toLowerCase();
      for (var i = 0; i < AdminNewsletterCampaign1.listEmail.length; i++) {
        if (tipology_search == "Gruppo") {
          if (AdminNewsletterCampaign1.listEmail[i].group.search(search) > -1) {
            AdminNewsletterCampaign1.listEmail[i].visible = true;
          } else {
            AdminNewsletterCampaign1.listEmail[i].visible = false;
          }
        } else {
          if (AdminNewsletterCampaign1.listEmail[i].email.search(res) > -1) {
            AdminNewsletterCampaign1.listEmail[i].visible = true;
          } else {
            AdminNewsletterCampaign1.listEmail[i].visible = false;
          }
        }
      }
    },

    confirmSendMailTestSender() {
      var AdminNewsletterCampaign1 = this;
      var res = AdminNewsletterCampaign1.listEmail;

      var data = {
        id: this.rowIdSelected,
        html: this.detailData.html,
        title: $("#title").val(),
        sender: $("#sender").val(),
        sender_email: $("#sender_email").val(),
        object: $("#object").val(),
        preview_object: $("#preview_object").val(),
        schedule_date_time: $("#schedule_date_time").val(),
        draft: draft1,
        res: res,
      };
      newsletterServices.confirmSendMailTestSender(data, function (result) {
        notificationHelpers.success("Email di test inviata con successo!");
        spinnerHelpers.hide();
      });
    },


onchangetitle(field, value) {
       var AdminNewsletterCampaign1 = this;

      var titleToTitle= $("#title").val();
      var cleanTitle = titleToTitle;  
      $("#url").val(cleanTitle);

      var title = $("#title").val(),
      cleanUrl = "";
      cleanUrl =
        "/newsletter" +
         "/" + title 
          .replace(/([,\!\^\$\.\*\÷\±\¿\¶\~\«\¢\ß\¥\™\©\®\+\?\|\<\>\-\&\€\%\=\"\'\£\#\;\:\§\@\°\s])/g, "-")    
          .replace(/([\à\s])/g, "a")
          .replace(/([\á\s])/g, "a")
          .replace(/([\è\s])/g, "e")
          .replace(/([\ê\s])/g, "e")
          .replace(/([\é\s])/g, "e")
          .replace(/([\ì\s])/g, "i")
          .replace(/([\í\s])/g, "i")
          .replace(/([\ò\s])/g, "o")
          .replace(/([\ó\s])/g, "o")
          .replace(/([\ù\s])/g, "u")
          .replace(/([\ú\s])/g, "u")
          .replace(/([\ż\s])/g, "z")
          .replace(/([\ź\s])/g, "z")
         	.replace(/([\ź\s])/g, "n")
          .replace(/([\ń\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")  
          .toLowerCase();
          
          $("#url").val(cleanUrl); 
    },


    confirmSaveNewEmail() {
      if (
        functionHelpers.isValued($("#title").val()) &&
        functionHelpers.isValued($("#schedule_date_time").val())
      ) {
        if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
          this.executeSaveNewEmail();
        }
      } else {
        notificationHelpers.warning(
          "è necessario compilare tutti i campi prima di procedere!"
        );
      }
    },

    confirmSaveDuplicateNewsletter(rowIdSelected) {
      var AdminNewsletterCampaign1 = this;
      var duplicaterecipients = false;
      var duplicatecontent = false;

      if ($("#duplicaterecipients").is(":checked")) {
        duplicaterecipients = true;
      } else {
        duplicaterecipients = false;
      }
      if ($("#duplicatecontent").is(":checked")) {
        duplicatecontent = true;
      } else {
        duplicatecontent = false;
      }
      spinnerHelpers.show();

      var data = {
        id: this.rowIdSelected,
        duplicaterecipients: duplicaterecipients,
        duplicatecontent: duplicatecontent,
      };
      newsletterServices.clone(data, function (result) {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("CloneCompleted")
        );
        AdminNewsletterCampaign1.loadTable();
        $("#tabTable").addClass("active");
        $("#tabDetail").removeClass("active");
        $("#tabAdminNewsletterPopupDuplicate").modal("hide");
      });
    },

    executeSaveNewEmail(id) {
      var AdminNewsletterCampaign1 = this;
      var res = AdminNewsletterCampaign1.listEmail;
      var draft1 = false;

      if ($("#draft1").is(":checked")) {
        draft1 = true;
      } else {
        draft1 = false;
      }

      if (functionHelpers.isValued(this.rowIdSelected) && this.rowIdSelected > 0) {
        var data = {
          id: this.rowIdSelected,
          html: this.detailData.html,
          title: $("#title").val(),
          sender: $("#sender").val(),
          sender_email: $("#sender_email").val(),
          object: $("#object").val(),
          preview_object: $("#preview_object").val(),
          schedule_date_time: $("#schedule_date_time").val(),
          url: $("#url").val(),
          draft: draft1,
          res: res,
        };

        if (($('#url').val() != "") && ($('#title').val() != "")  && ($('#object').val() != "") && ($('#sender').val() != "")) { 
       newsletterServices.updateCampaign(data, function (result) {
          if (result.data != "") {
            notificationHelpers.success("Campagna Salvata con Successo");
            AdminNewsletterCampaign1.loadTable();
            $("#tabTable").addClass("active");
            $("#tabDetail").removeClass("active");
          } else {
            notificationHelpers.error("Errore in salvataggio!");
          }
        });
        }else{
            notificationHelpers.warning("Attenzione,non puoi eseguire il salvataggio della campagna, i campi Titolo Campagna, Mittente, Oggetto e Url devono essere compilati!");
        }
        /*  newsletterServices.updateCampaign(data, function (result) {
          if (result.data != "") {
            notificationHelpers.success("Campagna Salvata con Successo");
            AdminNewsletterCampaign1.loadTable();
            $("#tabTable").addClass("active");
            $("#tabDetail").removeClass("active");
          } else {
            notificationHelpers.error("Errore in salvataggio!");
          }
        });*/

      } else {
        var data = {
          id: id,
          html: this.detailData,
          title: $("#title").val(),
          sender: $("#sender").val(),
          sender_email: $("#sender_email").val(),
          object: $("#object").val(),
          preview_object: $("#preview_object").val(),
          schedule_date_time: $("#schedule_date_time").val(),
          url: $("#url").val(),
          draft: draft1,
          res: res,
        };

        newsletterServices.insertCampaign(data, function (result) {
          if (result.data != "") {
            notificationHelpers.success("Campagna Inserita con Successo");
            AdminNewsletterCampaign1.loadTable();
            $("#tabTable").addClass("active");
            $("#tabDetail").removeClass("active");
          } else {
            notificationHelpers.error("Errore in salvataggio!");
          }
        });
      }
    },
  },
};
</script>
<style>
.graphic-card {
  background: #c8ced3;
  padding: 15px;
  border-radius: 5px;
}
.graphic-title {
  position: absolute;
}
.graphic-title h6 {
  font-weight: bold;
}
.graphic-title h3 {
  font-size: 20px;
  font-weight: bold;
  color: #521111;
}

.card-title-admin h1 {
  font-size: 40px;
  font-weight: lighter;
  color: #303c54;
}
.align-btns {
  position: absolute;
  z-index: 1;
  margin-top: 10px;
}

.form-textarea {
  resize: vertical;
  border: none !important;
  border-radius: 0px;
  padding-top: 25px;
  border-top: 1px solid #ededed;
}

.nav-tabs .nav-item {
  width: 25%;
}
.nav {
  border: 0px;
}
.nav-tabs .nav-link {
  width: 100%;
  border-radius: 0;
  color: #fff;
  background: #3c4b64;
  border-bottom: 3px solid #f45f00 !important;
  border: 0px;
}
.nav-tabs .nav-link.active {
  background: #2a3545 !important;
}

.nav-tabs .nav-link.active span {
  color: #fff;
}

.nav-tabs > .nav-item > .nav-link:not(.active) {
  background: #3c4b64 !important;
}
.cont-single-email {
  background: #f9f9f9;
  margin-bottom: 5px;
  padding: 10px;
  border-radius: 2px;
  box-shadow: 0px 2px 10px -8px rgb(0 0 0 / 70%);
  border-left: 3px solid #3c4b64;
  transition: all ease-in-out 0.25s;
}
.fa-trash {
  color: #f86c6b;
  float: right;
  cursor: pointer;
  margin-top: 4px;
}
.graphic-card {
    background:#fff;
}

#user_id_users + .select2,
#groupEmail + .select2,
#groupEmailQueryGroup + .select2 {
  height: calc(1.5em + 0.75rem + 2px);
  float: left;
  padding-top: 10px;
}
</style>